module.exports = __webpack_public_path__ + "img/SoftwareCopyright_1.0eb32387.png";